// Review-beleid (klantbeslissing):
// - Google-score en Google-reviewaantal komen UITSLUITEND live via de
//   Google Places-integratie (`useGoogleReviews`). Geen hardcoded scores.
// - Werkspot-aantal blijft volledig verborgen totdat het handmatig is bevestigd.
// - Reviews van verschillende platformen worden nooit opgeteld.
// - Er worden GEEN verzonnen of "curated" reviews getoond. Deze lijst blijft
//   leeg totdat er geverifieerde, herleidbare reviews handmatig worden toegevoegd.
export const reviews = [];

// Geen hardcoded fallback-score meer: null betekent "toon geen cijfer".
export const ratingAverage = null;

// Nooit een opgeteld totaal tonen.
export const totalReviewCount = null;
